<div class="button-list-container map-floating-button" [class.active]="isPopupVisible">
  <button mat-button class="map-top-button" (click)="showPopup($event)">
    <wlm-icon class="vertical-center-icon" icon="art_track"></wlm-icon>
  </button>
</div>
<div *ngIf="isPopupVisible" class="popup-wrapper-container popup-left">
  <wlm-map-popup-wrapper [titleKey]="'Map Legend'" [popupWidth]="'210px'" [showArrowIcon]="false">
    <ng-container popup-content>
      <ct-map-legend-items [mapLegendItems]="mapLegendItems"></ct-map-legend-items>
    </ng-container>
  </wlm-map-popup-wrapper>
</div>
